'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/**
 *  Copyright (c) 2017, Applitopia, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the MIT-style license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  
 */


var _immutableSorted = require('immutable-sorted');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var SubActionFactory = function () {
  function SubActionFactory(actionFactory, subSchemaPath) {
    _classCallCheck(this, SubActionFactory);

    this._actionFactory = actionFactory;
    this._subSchemaPath = subSchemaPath;
    this._prefix = subSchemaPath + '.';
  } //
  // Action creators
  //


  _createClass(SubActionFactory, [{
    key: 'batch',
    value: function batch(actions) {
      var action = this._actionFactory.batch(actions);

      return action;
    }
  }, {
    key: 'insert',
    value: function insert(collName, id, doc) {
      collName = this._prefix + collName;

      var action = this._actionFactory.insert(collName, id, doc);

      return action;
    }
  }, {
    key: 'update',
    value: function update(collName, id, doc) {
      collName = this._prefix + collName;

      var action = this._actionFactory.update(collName, id, doc);

      return action;
    }
  }, {
    key: 'remove',
    value: function remove(collName, id) {
      collName = this._prefix + collName;

      var action = this._actionFactory.remove(collName, id);

      return action;
    }
  }, {
    key: 'reset',
    value: function reset(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.reset(collName);

      return action;
    }
  }, {
    key: 'pause',
    value: function pause(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.pause(collName);

      return action;
    }
  }, {
    key: 'resume',
    value: function resume(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.resume(collName);

      return action;
    }
  }, {
    key: 'save',
    value: function save(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.save(collName);

      return action;
    }
  }, {
    key: 'restore',
    value: function restore(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.restore(collName);

      return action;
    }
  }, {
    key: 'saveOriginals',
    value: function saveOriginals(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.saveOriginals(collName);

      return action;
    }
  }, {
    key: 'retrieveOriginals',
    value: function retrieveOriginals(collName) {
      collName = this._prefix + collName;

      var action = this._actionFactory.retrieveOriginals(collName);

      return action;
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      var action = this._actionFactory.refresh();

      return action;
    }
  }, {
    key: 'value',
    value: function value(valueName, _value) {
      valueName = this._prefix + valueName;

      var action = this._actionFactory.value(valueName, _value);

      return action;
    }
  }, {
    key: 'customValue',
    value: function customValue(valueName, value) {
      valueName = this._prefix + valueName;

      var action = this._actionFactory.customValue(valueName, value);

      return action;
    }
  }, {
    key: 'custom',
    value: function custom(customName) {
      customName = this._prefix + customName;

      var action = this._actionFactory.custom(customName);

      return action;
    } //
    // Repo Actions
    //

  }, {
    key: 'createBranch',
    value: function createBranch(branchName) {
      var action = this._actionFactory.createBranch(branchName);

      return action;
    }
  }, {
    key: 'switchBranch',
    value: function switchBranch(branchName) {
      var action = this._actionFactory.switchBranch(branchName);

      return action;
    }
  }, {
    key: 'saveBranch',
    value: function saveBranch(branchName) {
      var action = this._actionFactory.saveBranch(branchName);

      return action;
    }
  }, {
    key: 'resetBranch',
    value: function resetBranch(branchName) {
      var action = this._actionFactory.resetBranch(branchName);

      return action;
    }
  }, {
    key: 'removeBranch',
    value: function removeBranch(branchName) {
      var action = this._actionFactory.removeBranch(branchName);

      return action;
    }
  }, {
    key: 'goForward',
    value: function goForward(steps) {
      var action = this._actionFactory.goForward(steps);

      return action;
    }
  }, {
    key: 'goBack',
    value: function goBack(steps) {
      var action = this._actionFactory.goBack(steps);

      return action;
    }
  }, {
    key: 'goLive',
    value: function goLive() {
      var action = this._actionFactory.goLive();

      return action;
    }
  }, {
    key: 'setOption',
    value: function setOption(optionName, optionValue) {
      var action = this._actionFactory.setOption(optionName, optionValue);

      return action;
    }
  }]);

  return SubActionFactory;
}();

exports.default = SubActionFactory;